class RegisterSuccessStore {

  use() {

  }
}

export default RegisterSuccessStore;
